//REPORTS
export const URL_PARKING_OCCUPANCY_REPORT =
  "/register/parking_occupancy_report";

export const URL_BOOKING_ADHOC_REPORT = "/register/booking_adhoc";
export const URL_PARKED_CARS_ADHOC_REPORT = "/register/parked_cars_adhoc";
export const URL_PAYMENT_ADHOC_REPORT = "/register/payments_adhoc";
export const URL_INVOICES_ADHOC_REPORT = "/register/invoices_adhoc";
export const URL_ECOUPON_ADHOC_REPORT = "/register/ecoupon_adhoc";

export const URL_REVENUE_PERFORMANCE = "/register/revenue_performance";
export const URL_TRANSACTABLE_ACCOUNTS_DETAILS =
  "/transactable_accounts_details";

export const URL_AGING_REPORT = "/register/aging_report";
export const URL_AGENT_PERFORMANCE_REPORT =
  "/register/agent_performance_report";
export const URL_COUPON_SALES_PERFORMANCE_REPORT =
  "/register/coupon_sales_report";

export const URL_REVENUE_SOURCE_PERFORMANCE_REPORT =
  "/register/revenue_source_performance";

export const URL_AGENT_DEPOSIT_PERFORMANCE_REPORT =
  "/register/agent_deposit_performance";

export const URL_AGENT_DEFAULTER_PERFORMANCE_REPORTS =
  "/register/agent_defaulter_performance";

export const URL_LOAN_APPLICATIONS = "/register/loan_application";
export const URL_LOAN_APPLICATIONS_RESCHEDULE =
  "/register/loan_application_reschedule";
export const URL_LOAN_APPLICATIONS_DRAFTS = "/register/loan_application_drafts";
export const URL_LEDGERS = "/register/ledgers";
export const URL_END_OF_DAY_REPORT = "/register/end_of_day_report";
export const URL_DAILY_COLLECTION_BALANCES =
  "/register/daily_collection_balances";
export const URL_REVENUE_LEDGER_REPORTS = "/register/revenue_ledger_report";
export const URL_INSTALMENTS = "/register/instalments";
export const URL_PURCHASE_ORDERS = "/register/purchase_order";
export const URL_INVENTORY = "/register/inventory";
export const URL_PRODUCTS = "/register/products";
export const URL_PAYROLL = "/register/payrolls";
export const URL_EXPENSES = "/register/expenses";
export const URL_REQUISITIONS = "/register/requisitions";
export const URL_OTHER_INCOME = "/register/other_income";
export const URL_PAYMENTS_REPORT = "/register/payments_report";
export const URL_LOAN_REPAYMENTS_REPORT = "/register/loan_repayments_report";
export const URL_LOAN_APPLICATIONS_REPORT = "/reports/loan-applications-report";
export const URL_DEBTORS_AGEING_REPORT = "/register/debtors_ageing_report";
export const URL_LEDGER_REPORT = "/register/ledger_report";
// USERS
export const URL_USERS = "/users";
export const URL_ROLES = "/roles";

// CONFIGURABLES
export const URL_CONFIGURABLES = "/configurables";
export const URL_VEHICLE_TYPES = "/vehicle_types";
export const URL_INTEREST_CONFIGURABLES = "/interest_configurables";
export const URL_PERIOD_CONFIGURABLES = "/period_configurables";
export const URL_FEES_CONFIGURABLES = "/fees_schedule_configurables";
export const URL_SUPPLIER_CONFIGURABLES = "/supplier_configurables";
export const URL_CHARTS_CONFIGURABLES = "/charts_of_accounts_configurables";
export const URL_ALLOWANCE_TYPES_CONFIGURABLES =
  "/allowance_types_configurables";
export const URL_PAYMENT_MODES_CONFIGURABLES = "/payment_modes_configurables";

// MASTER DATA
export const URL_MASTER_DATA = "/master_data";
export const URL_DISTRICTS = "/districts";
export const URL_COUNTIES = "/counties";
export const URL_SUB_COUNTIES = "/sub_counties";
export const URL_PARISHES = "/parishes";
export const URL_VILLAGES = "/villages";

//SMAKRT PARKING
export const URL_STREETS = "/streets";

export const URL_PARKINGS = "/parking_yards";
export const URL_SLOTS = "/slots";
export const URL_PARKING_RATES = "/parking_rates";
export const URL_PARKED_CARS = "/parked_cars";
export const URL_CURRENTLY_PARKED_CARS = "/currently_parked_cars";
export const URL_PARKED_CARS_SERVICES = "/parked_cars_services";

export const URL_PAYMENT_MODES = "/payment_modes";
export const URL_COUPON_SALES = "/coupon_sales";
export const URL_STICKER_TYPES = "/sticker_types";
export const URL_BOOKING_TYPE_CONFIGURABLE = "/booking_type_configurable";

//logs
export const URL_RECONCILIATION_ERROR_LOGS = "/reconciliation_error_logs";
export const URL_STATEMENT_LOGS = "/statement_logs";

//TELECOMS
export const URL_TELECOM_NETWORK_CODES = "/telecom_codes";

//Local Goverment logo
export const URL_LOCAL_GOVERNMENT_LOGO = "/local_government_logo";

//Penalty Setting
export const URL_PENALTY_SETTINGS = "/penalty_settings";

//Service Rates
export const URL_SERVICE_RATES = "/service_rates";

//Service Types
export const URL_SERVICE_TYPES = "/service_types";

//Surcharges Configurables
export const URL_SURCHARGE_CONFIGURABLES = "/surcharge_configurables";

//Surcharges
export const URL_SURCHARGES = "/surcharges";

//Penalties
export const URL_PENALTIES = "/penalties";

//BOOKING
export const URL_BOOKING_RESERVED = "/reserved_booking";
export const URL_BOOKING_STICKER = "/sticker_booking";
// export const URL_BOOKING_ADVANCE = "/advance_booking";
export const URL_BOOKING_ADVANCE = "/booking";
export const URL_BOOKINGS = "/bookings";
export const URL_BOOKING_RESERVATION_RATES = "/booking_rates";

export const URL_VEHICLE_CLAMPING = "/clamping";

export const URL_MAKE_PAYMENTS = "/make_payments";

export const URL_BOOKING_SUBMITTED = "/submitted_booking";
export const URL_BOOKING_APPROVED = "/approved_booking";
export const URL_BOOKING_REJECTED = "/rejected_booking";
export const URL_CAR_SLOT_MAPPING = "/car_slot_mappings";

export const URL_ADVANCES_BALANCE = "/advance_balances";
export const URL_ADVANCES_TRANSACTIONS = "/advances_transactions";
export const URL_LINKED_CARS = "/linked_cars";

//PAYMENTS
export const URL_PAYMENT_REQUESTS = "/payment_requests";
export const URL_PAID_REQUESTS = "/payments";
export const URL_LIQUIDATION_REQUESTS = "/liquidation_requests";

//CONFIG

export const URL_SYSTEM_ACCOUNTS = "/system_accounts";

//INVOICES
export const URL_BILLING_INVOICES = "/billing_invoices";

export const URL_RECONCILIATIONS = "/reconciliations";

// AUDIT ACTIVITY
export const URL_AUDIT_ACTIVITY = "/audit_activity";

// OFFICES
export const URL_DEPARTMENTS = "/departments";

// ORGANISATION
export const URL_ORGANISATIONS = "/organisations";

// PASSWORD RESET
export const URL_PASSWORD_RESET = "/password_reset";
export const URL_SETTINGS = "/settings";

// LOGIN
export const URL_LOGIN = "/login";
export const URL_REGISTER = "/register";

export const URL_REGISTER_BOOKING = "/register/booking";
export const URL_REGISTER_VIEW_STICKER_BOOKING = "/register/view_sticker";

// FEED
export const URL_FEES = "/fees";

// STATUS
export const PENDING = "pending";
export const SUBMITTED = "submitted";
export const REJECTED = "rejected";
export const DELIVERED = "delivered";
export const APPROVED = "approved";
export const DEFERRED = "deferred";
export const FOWARDED = "fowarded";
export const DISBURSED = "disbursed";
export const CLOSED = "closed";
export const DELAYED = "delayed";
export const REQUEST_REVERSAL = "reversal_requested";

// NEGOTIATED PAYMENTS
export const URL_NEGOTIATED_PAYMENTS = "/negotiated_payments";

// WAGES
export const URL_WAGES = "/wages";
export const URL_STAFF_WAGES = "/staff_wages";
export const URL_DAILY_WAGES_COLLECTIONS = "/daily_wages_collections";
export const URL_WEEKLY_WAGES_COLLECTIONS = "/weekly_wages_collections";
export const URL_PAYABLE_COLLECTIONS = "/payable_wages";
export const URL_WAGES_PAYMENTS_HISTORY = "/wage_payment_history";
export const URL_PAY_WAGES = "/pay_wages";
export const URL_WAGES_REPORT = "/register/wages_report";
export const URL_WAGE_CALCULATIONS_REPORT =
  "/register/wage_calculations_report";
export const URL_WAGE_ADVANCEMENTS_REPORT =
  "/register/wage_advancements_report";
export const URL_WEEKLY_COLLECTIONS_REPORT =
  "/register/weekly_collections_report";
export const URL_WAGES_CONFIGURATIONS = "/wages_configurations";
export const URL_WAGES_BONUS = "/wages_bonus";
export const URL_WEEKLY_COMMISSION = "/register/weekly_commissions";
export const URL_FIXED_WAGES = "/fixed_wages";
export const URL_PAY_WEEK_CONFIGURATION = "/pay_week_configuration";
export const URL_WAGE_ADVANCEMENTS = "/wage_advancements";
export const URL_PETTY_CASH_REQUISITION = "/petty_cash_requisition";
export const URL_STAFF_WAGES_REQUISITION = "/staff_wages_requisition";

//ASSETS
export const URL_ASSET_CATEGORIES = "/asset_categories";
export const URL_ASSETS = "/assets";
export const URL_ASSETS_DASHBOARD = "/assets/dashboard";
export const URL_ASSET_TRANSFERS = "/asset_transfers";
export const URL_ASSET_STATUS_UPDATES = "/asset_status_updates";
export const URL_ASSET_STOCK_COUNTS = "/asset_stock_counts";
export const URL_ASSET_DISPOSALS = "/asset_disposals";
export const URL_ASSETS_REPORT = "/register/assets_report";
export const URL_ASSET_TRANSFERS_REPORT = "/register/asset_transfers_report";
export const URL_ASSET_STATUS_UPDATES_REPORT =
  "/register/asset_status_updates_report";
export const URL_ASSET_STOCK_VARIANCE_REPORT =
  "/register/asset_stock_variance_report";

//USSD LOGS
export const URL_USSD_LOGS = "/ussd_logs";
export const URL_USSD_STICKERS = "/ussd_stickers";

// REVERSAL REQUESTS
export const URL_REVERSAL_REQUESTS = "/reversal_requests";
export const URL_REVERSAL_HOLDINGS = "/reverse_transaction";
export const URL_DORMANT_ACCOUNTS = "/dormant_accounts";

//NOTIFICATIONS
export const URL_NOTIFICATIONS = "/notifications";

//DEPLOYMENTS
export const URL_ENFORCEMENT_TEAMS = "/enforcement_teams";
export const URL_DEPLOYMENTS = "/deployments";
